export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-chord/index.js
// module id = 127
// module chunks = 0